import gql from 'graphql-tag';

// Vehicles a driver can choose for a run: same server search as the classic
// vehicle selector (vehicle name), one page at a time.
export const GET_SERVICE_RUN_VEHICLES = gql`
	query($page: Int!, $perPage: Int!, $filter: VehiclePageFilter) {
		getVehicles(page: $page, perPage: $perPage, sortBy: "name", sortDirection: 1, filter: $filter) {
			items {
				id
				name
				registration
			}
			count
		}
	}
`;
